export default {
  s3: {
    REGION: "us-east-1",
    BUCKET: "dashboard-app-api-dev"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://v7gspgbyt4.execute-api.us-east-1.amazonaws.com/dev"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_TUWfdSayS",
    APP_CLIENT_ID: "2hjisi039le8fm2e34noospi40",
    IDENTITY_POOL_ID: "us-east-1:8df53e12-1815-492b-9aca-b0b9985b940a"
  }
};


// WEBPACK FOOTER //
// ./src/aws-config.js